import React from 'react';

import clsx from 'clsx';

import { Text } from '@atoms';

import { AuthContext, loginReasons } from '@modules/base/auth';

import classes from './nav-logout.module.scss';

type Props = {
  desktop?: boolean;
  mobile?: boolean;
  auth: AuthContext;
};

export const NavLogout = ({ desktop, mobile, auth }: Props) => {
  return (
    <div
      onClick={async () =>
        await auth.handleLoginRedirect({
          withLogoutRequest: true,
          reason: loginReasons.logout,
        })
      }
      className={clsx(
        desktop && classes.nav__logoutDesktop,
        mobile && classes.nav__logoutMobile,
      )}
    >
      <Text
        message={{ id: 'nav.links.logout' }}
        className={classes.nav__logoutText}
        type="reduced"
        color="vivid_blue"
      />
    </div>
  );
};
